import {
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

interface getCommitteeHistoryDataTableStructureProps {
  serverQuery?: DataTableServerQuery;
}

export const getCommitteeDataTableStructure = ({ serverQuery }: getCommitteeHistoryDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.history_table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };

  const firstNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.history_table.firstName',
    accessorKey: 'firstName',
    variant: DataTableColumnVariant.TEXT,
  };

  const lastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.history_table.lastName',
    accessorKey: 'lastName',
    variant: DataTableColumnVariant.TEXT,
  };

  const emailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.history_table.email',
    accessorKey: 'email',
    variant: DataTableColumnVariant.TEXT,
  };

  const startDateColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'settings.committee.history_table.startDate',
    accessorKey: 'dateDebut',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm:ss',
    },
  };

  const endDateColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'settings.committee.history_table.endDate',
    accessorKey: 'dateFin',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm:ss',
    },
  };

  return {
    singular: 'settings.committee.history_table.singular',
    plural: 'settings.committee.history_table.plural',
    columns: [idColumn, firstNameColumn, lastNameColumn, emailColumn, startDateColumn, endDateColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    serverQuery,
    enableServerActions: true,
    searchableFields: ['id', 'startDateColumn', 'endDateColumn'],
  };
};
